import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Share } from '../entities/share.entity';
import { map, switchMap } from 'rxjs/operators';
import { FragmentId } from '../../records/entities/metadata/metadata.entity';
import { HttpClient } from '@angular/common/http';
import { EnvironmentConfigService } from '../../../config/services/environment-config.service';

@Injectable({
    providedIn: 'root'
})
export class ShSharesDataService {
    private readonly SHARES_ENDPOINT = 'v2/shares';

    // Uses basic http client so we can use this service in the token refresh interceptor
    private readonly http: HttpClient = inject(HttpClient);
    private readonly config: EnvironmentConfigService = inject(EnvironmentConfigService);

    constructor() {}

    public getShareById(shareId: string): Observable<Share> {
        return this.baseUrl$.pipe(
            switchMap(baseUrl => this.http.get<Share>(`${baseUrl}/${this.SHARES_ENDPOINT}/${shareId}`))
        );
    }

    public getShareToken(shareId: string): Observable<string> {
        return this.baseUrl$.pipe(
            switchMap(baseUrl =>
                this.http
                    .post<{ ShareToken: string }>(`${baseUrl}/${this.SHARES_ENDPOINT}/${shareId}/token`, {})
                    .pipe(map(tokenObject => tokenObject.ShareToken))
            )
        );
    }

    public createShare(
        fragmentIds: FragmentId[],
        expiryDate: Date | null,
        loginRequired: boolean,
        exportable: boolean
    ): Observable<Share> {
        return this.baseUrl$.pipe(
            switchMap(baseUrl =>
                this.http.post<Share>(`${baseUrl}/${this.SHARES_ENDPOINT}`, {
                    Records: fragmentIds,
                    ExpiryDate: expiryDate,
                    RequiresLogin: loginRequired,
                    Exportable: exportable
                })
            )
        );
    }

    public updateShare(shareId: string, share: Share): Observable<boolean> {
        return this.baseUrl$.pipe(
            switchMap(baseUrl => this.http.post<boolean>(`${baseUrl}/${this.SHARES_ENDPOINT}/${shareId}`, share))
        );
    }

    public get baseUrl$(): Observable<string> {
        return this.config.get('apiUrl').pipe(map(apiUrl => apiUrl.replace(/\/$/, '')));
    }
}
